import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUser } from "@/contexts";
import { AuthModal, Header, HeaderMenuItem, Footer } from "@/components";

const SiteLayout = () => {
  const navigate = useNavigate();
  const { userData } = useUser();
  const isLogged = Boolean(userData);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  const menuItems: HeaderMenuItem[] = [
    ...(isLogged
      ? [
          {
            label: "Início",
            action: (close: () => void) => {
              close();
              navigate("/inicio");
            },
          },
        ]
      : []),
    ...(!isLogged
      ? [
          {
            label: "Entrar",
            className: "link-login",
            action: (close: () => void) => {
              close();
              setIsAuthModalOpen(true);
            },
          },
        ]
      : []),
    {
      label: "Como Funciona",
      action: (close: () => void) => {
        close();
        navigate("/como-funciona");
      },
    },
    {
      label: "Sobre Nós",
      action: (close: () => void) => {
        close();
        navigate("/sobre-nos");
      },
    },
    {
      label: "Planos",
      action: (close: () => void) => {
        close();
        navigate("/planos");
      },
    },
  ];

  return (
    <div className="app-shell min-h-screen flex flex-col">
      <Header menuItems={menuItems} />

      <main className="app-main flex-1">
        <Outlet />
      </main>

      <Footer />

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </div>
  );
};

export default SiteLayout;
